import { Box, Tag } from '@coolblue-development/freddy';
import { ReactElement } from 'react';

import { TooltipContainer } from '../../TooltipContainer';
import CurrentStoreStockIconTag from './CurrentStoreStockIconTag';

type CurrentStoreStockIconProps = {
  stockCount?: number;
  url: string;
  index: number;
  totalIndices: number;
};

const CurrentStoreStockIcon = ({
  stockCount,
  url,
  index,
  totalIndices
}: CurrentStoreStockIconProps): ReactElement => {
  if (stockCount === null || stockCount === undefined) {
    return (
      <Box>
        <Tag variant='subtle'>- in this store</Tag>
      </Box>
    );
  }

  const message = stockCount === 0 ? 'None in this store' : `${stockCount} in this store`;
  const intent = stockCount <= 3 ? 'promo' : 'positive';

  return (
    <TooltipContainer
      iconLabel='Open Iris product dashboard'
      data-testid='current-store-stock-icon'
    >
      <CurrentStoreStockIconTag
        url={url}
        index={index}
        totalIndices={totalIndices}
        stockCount={stockCount}
        message={message}
        intent={intent}
      />
    </TooltipContainer>
  );
};

export default CurrentStoreStockIcon;
